import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Textarea } from '@/components/ui/textarea';
import { Label } from '@/components/ui/label';
import type { StructuredHouseRules } from '../../types';

interface HouseRulesEditorProps {
  value: StructuredHouseRules;
  onChange: (value: StructuredHouseRules) => void;
}

const HouseRulesEditor: React.FC<HouseRulesEditorProps> = ({ value, onChange }) => {
  const freeText = value.freeText || { de: '', en: '' };

  return (
    <div className="space-y-4">
      <Card>
        <CardHeader className="pb-4">
          <CardTitle className="text-base">Hausregeln</CardTitle>
          <CardDescription>
            Hausregeln als Fliesstext eingeben – Stichworte, Absätze oder nummerierte Liste.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="space-y-2">
            <Label>Deutsch</Label>
            <Textarea
              value={freeText.de}
              onChange={(e) =>
                onChange({ ...value, freeText: { ...freeText, de: e.target.value } })
              }
              placeholder="z.B. Rauchen verboten. Haustiere auf Anfrage. Ruhezeit ab 22 Uhr. Abfall trennen..."
              className="min-h-[180px] resize-y"
            />
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default HouseRulesEditor;
